$.ready(function() {
	game.on('ready', function() {
		setTimeout(function() {
			if (!game.sounds.sounds) { return; }
			if (!game.sounds.sounds.win) { game.sounds.sounds.win = {}; }
			game.sounds.sounds.win.bigwin_2 = null;
			game.sounds.sounds.win.bigwin_3 = null;
			game.panel.bigwin.levels[5][0].duration = 5;
			game.panel.bigwin.levels[5][1].duration = .0001;
			game.panel.bigwin.levels[5][2].duration = .0001;
		}, 1);
	});
	game.on('spin_pre_done', function() {
		var factor = 0;
		var lever = 0;

		if (game.last && game.last._cost) {
			factor = game.last.win / (game.last._cost);
		}
		else if (game.old && game.old._cost) {
			factor = game.last.win / (game.old._cost);
		}

		var index = 0;
		for (index = 0; index < game.panel.bigwin.breakpoints.length; index++) {
			if (factor < game.panel.bigwin.breakpoints[index]) {
				break;
			}
		}

		if (index >= 3) {
			game.sounds.sounds.win.bigwin_1 = game.sounds.sounds.win.konami_1;
			game.panel.bigwin.levels[5][0].duration = 5;
			if (game.sounds.fallback) {
				game.sounds.fallback.win.bigwin_1 = game.sounds.sounds.win.konami_1;
			}
		}
		if (index >= 4) {
			game.sounds.sounds.win.bigwin_1 = game.sounds.sounds.win.konami_2;
			game.panel.bigwin.levels[5][0].duration = 12;
			if (game.sounds.fallback) {
				game.sounds.fallback.win.bigwin_1 = game.sounds.sounds.win.konami_2;
			}
		}
		if (index >= 5) {
			game.sounds.sounds.win.bigwin_1 = game.sounds.sounds.win.konami_3;
			game.panel.bigwin.levels[5][0].duration = 15;
			if (game.sounds.fallback) {
				game.sounds.fallback.win.bigwin_1 = game.sounds.sounds.win.konami_3;
			}
		}
	});

});



/** WEBPACK FOOTER **
 ** ./public-src/js/sound_switch.js
 **/